<template>
  <div v-if="data && data.length" class="activity-timeline side-hs-activity">
    <div style="position: relative">
      <TitleBlock
        :text="'Activity Timeline'"
        :size="'small'"
        color="corporateblue"
        :type="'alternative'"
      />
      <Tip
        :tip-content="'A series of updates laying out the legislative process of a new bill/law, including the consultation process if relevant, in date order.'"
        class="tip-button-act"
      />
    </div>
    <div class="activity-timeline-list">
      <div
        v-for="item in data"
        :key="item.nid"
        class="timeline-item"
        :class="{
          'informative-update': item.classification === 'Informative',
          'indicative-update': item.classification === 'Indicative',
          'actionable-update': item.classification === 'Actionable',
        }"
      >
        <div class="timeline-item__date">
          Release date <Date :text="item.releaseDate" />
        </div>
        <div class="timeline-item__name">
          <a :href="item.url">{{ item.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityTimeline",
  components: {
    TitleBlock: () => import("../elements/TitleBlock"),
    Date: () => import("../elements/Date"),
    Tip: () => import("../elements/Tip"),
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.tip-button-act {
  left: 17rem;
  top: 0.6rem;
  width: 14px;
  position: absolute;
}

.activity-timeline a {
  color: black;
  text-decoration: none;
  font-size: 1.4rem;
}

.activity-timeline a:vistited {
  color: black;
}

.side-hs-activity .actionable-update:before {
  background: #ff0000 !important;
}

.side-hs-activity .indicative-update:before {
  background: #ffa500 !important;
}

.informative-update:before {
  background: #008000 !important;
}

.activity-timeline .title-block {
  margin-bottom: 0rem !important;
}

.activity-timeline {
  margin-bottom: 3rem;

  .title-block {
    margin-bottom: -0.1rem;
  }

  &-list {
    border: 1px solid $border;
    border-left: none;
    padding-top: 2rem;
    padding-right: 10px;
  }
}

.timeline-item {
  padding-bottom: 2rem;
  padding-left: 2rem;
  border-left: 1px solid $border;
  position: relative;
  margin-left: 0.5rem;

  &::before {
    content: "";
    width: 0.8rem;
    height: 0.8rem;
    background: #e2d6b2;
    border: 1px solid $border;
    border-radius: 50%;
    position: absolute;
    left: -5.5px;
    top: 0;
    display: block;
  }

  &:last-of-type {
    border: none;
    margin-left: 0.6rem;
  }

  &__date {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    line-height: 0.9rem;

    .date {
      margin-left: 1rem;
    }
  }

  &__name {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 120%;
  }
}
</style>
